<template>
  <!-- Faded background -->
  <div class="faded-background" @mousedown="cancel">
    <!-- Modal form -->
    <div class="modal" :style="modalStyles" @mousedown.stop>
      <!-- Modal header -->
      <div class="header">
        <span class="title">{{ title }}</span>
      </div>

      <!-- Modal body -->
      <div class="body">
        <!-- Error message -->
        <span v-if="error" class="modal__row error-message">
          {{ error }}
        </span>

        <!-- Slot for content -->
        <slot v-if="!loading" name="body">
          <!-- Content -->
        </slot>

        <!-- Loader -->
        <div v-else class="loader-container">
          <circle2
            color="var(--main-bg-color)"
            background="var(--sidebar-bg-color)"
            stroke="4px"
            size="60px"
          ></circle2>
        </div>
      </div>

      <!-- Modal footer -->
      <div class="footer">
        <!-- Slot for buttons/subscribes -->
        <slot name="footer"> </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle2 } from "vue-loading-spinner";

// @group Dialog
// Modal form template
export default {
  name: "AdminModal",
  components: {
    Circle2
  },
  props: {
    // modal title
    title: {
      type: String,
      default: "Modal form"
    },
    // error message
    error: {
      type: String,
      default: null
    },
    // is modal loading now
    loading: {
      type: Boolean,
      default: false
    },
    // modal form styles
    modalStyles: {
      type: Object,
      default: () => new Object()
    }
  },
  methods: {
    cancel() {
      // User clicked 'Cancel' button
      this.$emit("cancel");
    }
  }
};
</script>

<style scoped>
.faded-background {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: rgba(0, 0, 0, 0.3);
  z-index: var(--top-layer);
}

.modal {
  display: flex;
  flex-direction: column;

  max-height: 90%;
  min-width: 200px;
  min-height: 100px;

  padding: 20px 30px;

  border-radius: 25px;
  background-color: var(--main-bg-color);
}

.long .modal {
  min-width: 500px;
}

@media only screen and (max-width: 600px) {
  .long .modal {
    box-sizing: border-box;
    min-width: 90%;
  }
}

.header {
  padding-bottom: 0.5em;

  text-align: center;
  border-bottom: 1px var(--sidebar-bg-color) solid;
}

.body {
  overflow: auto;
  min-height: 20px;
  padding: 15px 0;
}

.footer {
  padding-top: 0.5em;

  display: flex;
  justify-content: center;
  align-items: center;

  border-top: 1px var(--sidebar-bg-color) solid;
}

.error-message {
  justify-content: center;
  color: var(--error-color);
}

.modal-btn {
  display: flex;
  justify-content: center;
  align-items: center;

  font-family: var(--sans-font);

  min-width: 80px;
  padding: 0 7px;
  height: 42px;
  border-radius: 5px;

  cursor: pointer;
  user-select: none;
}
.modal-btn:not(:last-child) {
  margin-right: 0.5em;
}

.cancel-btn {
  color: var(--navbar-bg-color);
  background-color: var(--sidebar-bg-color);
}
.cancel-btn:hover {
  background-color: var(--sidebar-sel-bg-color);
}

.submit-btn {
  color: var(--navbar-bg-color);
  background-color: var(--main-bg-color);
  border: 1px var(--navbar-bg-color) solid;
}
.submit-btn:hover {
  color: var(--main-bg-color);
  background-color: var(--navbar-bg-color);
}
</style>

<style>
.modal .body .modal__row {
  display: flex;
}
.modal .body .modal__row:not(:last-child) {
  margin-bottom: 25px;
}

.modal .body .modal__field {
  display: flex;
  flex-direction: column;
}
.modal .body .modal__field {
  margin-right: 25px;
}
.modal .body .modal__field:last-child {
  margin-right: 0;
}

.modal .body .modal__label {
  font-family: var(--sans-font);
  font-weight: bold;

  padding-bottom: 5px;
}

.modal .body input,
.modal .body select {
  font-family: var(--sans-font);
  font-size: var(--norm-font-sz);

  background-color: var(--sidebar-bg-color);
  border-radius: 5px;
  border: 1px solid black;

  padding: 5px;
}
.modal .body input.error {
  border-color: var(--error-color);
}

Scrollbars
/* width */
.modal ::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.modal ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

/* Handle */
.modal ::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}

/* Handle on hover */
.modal ::-webkit-scrollbar-thumb:hover {
  background: var(--sidebar-bg-color);
  border-radius: 10px;
}

@media only screen and (max-width: 640px) {
  .modal__row {
    flex-direction: column;
  }

  .modal__row .modal__field:not(:last-child) {
    margin-bottom: 25px;
  }
}
</style>
